/**
 * Светлая и тёмная тема кабинета.
 *
 * ТРИ СОСТОЯНИЯ, А НЕ ДВА, И ТРЕТЬЕ — ГЛАВНОЕ. «Светлая», «тёмная»
 * и «как в системе». Последнее — умолчание: человек, включивший тёмную
 * тему в системе, ждёт её и здесь, а тот, кто не включал, не должен
 * получить тёмный кабинет из-за чужого решения о моде.
 *
 * ВЫБОР ПЕРЕЖИВАЕТ ПЕРЕЗАГРУЗКУ И ПОБЕЖДАЕТ СИСТЕМУ В ОБЕ СТОРОНЫ.
 * Выбрал светлую при системной тёмной — значит светлая, и наоборот.
 * Иначе переключатель выглядит сломанным: нажал, а через день опять
 * не то.
 *
 * ЗДЕСЬ ТОЛЬКО РАЗБОР. Ни хранилища, ни документа: решение о том, какую
 * тему показать, должно проверяться на выдуманных значениях.
 */

export type ThemeChoice = 'light' | 'dark' | 'system';
export type Theme = 'light' | 'dark';

export const THEME_KEY = 'rk_theme';

/**
 * Что лежит в хранилище — в выбор.
 *
 * МУСОР ЧИТАЕТСЯ КАК «КАК В СИСТЕМЕ», А НЕ КАК СВЕТЛАЯ. Запись могла
 * остаться от прежней редакции или испортиться; принять её за явный
 * выбор значит навязать человеку тему, которую он не выбирал.
 */
export function choiceOf(stored: string | null): ThemeChoice {
  return stored === 'light' || stored === 'dark' ? stored : 'system';
}

/** Какую тему показывать на самом деле. */
export function themeOf(choice: ThemeChoice, systemDark: boolean): Theme {
  if (choice === 'system') return systemDark ? 'dark' : 'light';
  return choice;
}

/**
 * Что будет по нажатию на переключатель.
 *
 * ПЕРЕКЛЮЧАТЕЛЬ ХОДИТ ПО КРУГУ ИЗ ДВУХ, А НЕ ИЗ ТРЁХ. Третье состояние
 * («как в системе») задаётся один раз при первом заходе и достижимо
 * только сбросом. Кнопка, которая на третьем нажатии возвращает то же
 * самое, что было на первом, — загадка: человек нажимает её, чтобы
 * получить светлую или тёмную, а не чтобы выбрать способ выбора.
 *
 * Отсюда простое правило: нажатие переключает на ПРОТИВОПОЛОЖНОЕ ТОМУ,
 * ЧТО СЕЙЧАС НА ЭКРАНЕ, — даже если сейчас на экране системная тема.
 */
export function nextChoice(shown: Theme): ThemeChoice {
  return shown === 'dark' ? 'light' : 'dark';
}

/** Подпись переключателя: говорит, что БУДЕТ, а не что есть. */
export function themeLabel(shown: Theme): string {
  return shown === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему';
}
